import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './shared/ui/styles/globals.css';
import App from './app/App';
import { initObservability } from './shared/observability';

// Initialize observability BEFORE rendering so errors during boot are captured.
// This is a no-op when VITE_MODULE_OBSERVABILITY is falsy or VITE_SENTRY_DSN is absent.
// The dynamic import inside initObservability() means @sentry/react is never loaded
// when the module is disabled.
void initObservability();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found in document.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
